//@state
export interface authState {
  currentCourse: {},
  preRegisterUsername: null,
  preRegisterCode: null,
  hasNationalCode: false,
  nationalCodePreview: null,
  parvandehInfo: {},
  extraFields: null,
}

export const initialState: authState = {
  currentCourse: {},
  preRegisterUsername: null,
  preRegisterCode: null,
  hasNationalCode: false,
  nationalCodePreview: null,
  parvandehInfo: {},
  extraFields: null,
}







